import React, { useState } from 'react'

import { Tab } from 'components'

import ManagerialCockpitNgt1 from './components/ManagerialCockpitNgt1/ManagerialCockpitNgt1'
import ManagerialCockpitNgt2 from './components/ManagerialCockpitNgt2/ManagerialCockpitNgt2'

const ManagerialCockpit: React.FC = () => {
  const tabs = ['Cockpit NGT 1', 'Cockpit NGT 2']
  const [selectedTab, setSelectedTab] = useState(0)
  const handleChange = (_, newValue) => setSelectedTab(newValue)

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 ? (
        <ManagerialCockpitNgt1 />
      ) : (
        <ManagerialCockpitNgt2 />
      )}
    </>
  )
}

export default ManagerialCockpit
